import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../react-core/Flux/BaseStore";

import { ResearchISTDispatcher } from "./Variable";

export interface ResearchISTStoreState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any[];
    getDataFunc?: (curPage: number) => void;
    isBasicSearch?: boolean;
}

export class ResearchISTStoreStatic extends BaseStore<ResearchISTStoreState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ResearchISTDispatcher, (actionData) => this.onResearchISTStoreResponse(actionData));
    }

    public getLastResult(): ResearchISTStoreState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getIsBasicSearch() {
        return this.getState().isBasicSearch;
    }

    public search(curPage: number) {
        const func = this.getState().getDataFunc;
        if (func) {func(curPage);}
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): ResearchISTStoreState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onResearchISTStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({
                    actionType: actionData.actionType,
                    getDataFunc: actionData.payload,
                    isBasicSearch: actionData.payload == null,
                });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
